import { render, staticRenderFns } from "./SendPush.vue?vue&type=template&id=51a6f250&scoped=true"
import script from "./SendPush.vue?vue&type=script&lang=js"
export * from "./SendPush.vue?vue&type=script&lang=js"
import style0 from "./SendPush.vue?vue&type=style&index=0&id=51a6f250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6f250",
  null
  
)

export default component.exports